module.exports = __webpack_public_path__ + "static/media/InSlots.641f34d3.svg";